<template>
  <div class="my-page-component admin-outer-wrapper">
    <div class="admin-nav">
      <ul>
        <li :class="$route.name === 'admin-settings' ? 'active' : ''" v-if="can('settings')"><router-link :to="{ name: 'admin-settings' }">Inställningar</router-link></li>
        <li :class="$route.name === 'admin-accomodations' ? 'active' : ''" v-if="can('accomodations')"><router-link :to="{ name: 'admin-accomodations' }">Boende</router-link></li>
        <li :class="$route.name === 'admin-command-sync' ? 'active' : ''" v-if="can('commands')"><router-link :to="{ name: 'admin-command-sync' }">Synka</router-link></li>
        <li :class="$route.name === 'admin-texts' ? 'active' : ''" v-if="can('texts')"><router-link :to="{ name: 'admin-texts' }">Texter</router-link></li>
        <li :class="$route.name === 'admin-stats-orders' ? 'active' : ''" v-if="can('orderlist')"><router-link :to="{ name: 'admin-stats-orders' }">Ordrar</router-link></li>
        <li :class="$route.name === 'admin-email-report' ? 'active' : ''" v-if="can('emailreport')"><router-link :to="{ name: 'admin-email-report' }">E-postrapport</router-link></li>
        <li :class="$route.name === 'admin-notifications' ? 'active' : ''" v-if="can('notifications')"><router-link :to="{ name: 'admin-notifications' }">Logg</router-link></li>
        <li :class="$route.name === 'admin-gdpr-cleanup' ? 'active' : ''" v-if="can('gdpr')" class="disabled"><router-link :to="{ name: 'admin-gdpr-cleanup' }">GDPR</router-link></li>
        <li :class="$route.name === 'admin-translations' ? 'active' : ''" v-if="can('translations')" class="disabled"><router-link :to="{ name: 'admin-translations' }">Översättning</router-link></li>
      </ul>
      <hr />
      <ul>
        <li><router-link :to="{ name: 'login' }">Gå till logga ut</router-link></li>
      </ul>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '@/classes/API';
import Login from '@/components/payments/Login';

import moment from 'moment';

export default {
  data() {
    return {
      orders: [],
      user: {},
    };
  },
  components: {
    Login,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    activeTab() {
      return this.$route.meta.page;
    },
  },
  methods: {
    async fetch() {
      const { user } = await API.get('/account/user');
      if (user) {
        this.user = user;
      }
    },
    can(what) {
      return this.user[`can_${what}`];
    },
    login() {
      this.fetch();
    },
  },
  mounted() {
    this.from = moment().startOf('isoweek').format('YYYY-MM-DD');
    this.to = moment().endOf('isoweek').format('YYYY-MM-DD');
    this.fetch();
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'


.my-name
  font-size: 13px;
  font-weight: 300;
  text-align: center;
  color: #262626;
  padding 15px
  border-bottom solid 1px #ececec;

.login
  padding 50px

.admin-nav
  admin-nav()

.my-page-component .inner
  admin-container()
</style>



// WEBPACK FOOTER //
// AdminPage.vue?45ab1c48